export const fieldStructure = Object.freeze({
  kind: 'field',
  item_id: null,
  name: "",
  type: "",
  logic: {},
  errors: {},
  hasErrors: false,
  options: {
    required: false,
    fieldTypeCfg: { data: [] }, //select/checkbox: [{ name, allowComment }]
    alarms: false,
  },
  show_if: [],               // [{ field: '<item_id>', op: '==', value: true }]
  show_logic: 'all',         // 'all' (AND) | 'any' (OR)
});

// Solo-UI para secciones
export const sectionStructure = Object.freeze({
  kind: 'section',
  section_id: null,
  name: "",
  collapsed: false,
  children: [],
});

export const fieldTypes = [
  {
    name: 'custom_forms.types.select',
    type: 'select',
    data_type: 'select',
    icon: 'select.svg',
    config: [{}],
  },
  {
    name: 'custom_forms.types.checkbox',
    type: 'checkbox',
    data_type: 'checkbox',
    icon: 'checkbox.svg',
    config: [{}],
  },
  {
    name: "custom_forms.types.text_answer",
    type: "text_answer",
    data_type: "textarea",
    icon: "text-answer.svg",
    config: [],
  },
  {
    name: "custom_forms.types.users",
    type: "users",
    data_type: "component",
    icon: "UsersIcon",
    config: [],
  },
  {
    name: "custom_forms.types.units",
    type: "units",
    data_type: "component",
    icon: "MapPinIcon",
    config: [],
  },
  {
    name: "custom_forms.types.date",
    type: "date",
    data_type: "date",
    icon: "CalendarIcon",
    config: [],
  },
  {
    name: "custom_forms.types.minutes",
    type: "minutes",
    data_type: "number",
    icon: "ClockIcon",
    config: [
      { key: "min", default: 0 },
      { key: "max", default: null },
      { key: "required", default: false },
    ],
  },
  {
    name: "custom_forms.types.time_hhmm",
    type: "time_hhmm",
    data_type: "time",
    icon: "ClockIcon",
    config: [
      { key: "min", default: null },
      { key: "max", default: null },
      { key: "required", default: false },
    ],
  },
  {
    name: "custom_forms.types.numeric",
    type: "numeric",
    data_type: "number",
    icon: "HashIcon",
    config: [
      { key: "decimals", default: 0 },
      { key: "min", default: null },
      { key: "max", default: null },
      { key: "allowNegative", default: false },
      { key: "required", default: false },
    ],
  },
  {
    name: "custom_forms.types.duration_hm",
    type: "duration_hm",
    data_type: "component",
    icon: "ClockIcon",
    config: [
      { key: "minHours", default: 0 },
      { key: "maxHours", default: null },
      { key: "required", default: false },
    ],
  },
    {
    name: "custom_forms.types.duration_ms",
    type: "duration_ms",
    data_type: "component",
    icon: "ClockIcon",
    config: [
      { key: "minMinutes", default: 0 },
      { key: "maxMinutes", default: null },
      { key: "required", default: false },
    ],
  },
  {
    name: "custom_forms.types.duration_hms",
    type: "duration_hms",
    data_type: "component",
    icon: "ClockIcon",
    config: [
      { key: "maxHours", default: 24 },
      { key: "required", default: false },
    ],
  },
  //files section
  {
    name: 'custom_forms.types.files_section',
    type: 'files_section',
    data_type: 'component',   // buider renders a FileUploadWithPreview
    icon: 'FileIcon',
    config: [],
  },
];
